import BreadCrumb from 'lib/designSystem/BreadCrumb';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import React, { useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import Report from './Components/Report';
import Summary from './Components/Summary';

const tabs = [
  {
    label: 'Resumen',
    component: <Summary />,
    path: 'summary',
    index: 0,
  },
  {
    label: 'Reporte',
    component: <Report />,
    path: 'report',
    index: 1,
  },
];

const Business = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { companyId, businessIdentifier, page } = useParams<{
    companyId: string;
    businessIdentifier: string;
    page: string;
  }>();

  const businessName = searchParams.get('businessName');

  const breadcrumbTitle = useMemo(() => {
    return businessName || businessIdentifier || 'Empresa';
  }, [businessName, businessIdentifier]);

  const startValue = useMemo(() => {
    const foundIndex = tabs.findIndex((x) => x.path === page);
    return foundIndex >= 0 ? foundIndex : 0;
  }, [page]);

  const handleNavigation = (index: number) => {
    const url = `/funds/business/${companyId}/${businessIdentifier}/${tabs[index].path}`;
    const queryString = businessName
      ? `?businessName=${encodeURIComponent(businessName)}`
      : '';
    navigate(`${url}${queryString}`);
  };

  return (
    <>
      <BreadCrumb
        links={[
          { title: 'Fondos', link: '/funds/accounts' },
          { title: breadcrumbTitle, link: '#' },
        ]}
      />
      <EnhancedTab
        startValue={startValue}
        tabs={tabs}
        onTabChange={handleNavigation}
      />
    </>
  );
};

export default Business;
